<template>
  <div v-show="chooseMediaPop.isShow" class="choose-media-pop">
    <section class="pop-content" @click.stop>
      <div class="g-close" @click="hideChooseMediaPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <header class="header">
        <h2>选择商品上架媒体</h2>
      </header>
      <section>
        <section class="radio-wrap">
          <qc-radio v-show="isBindWs" v-model="media" value="ws">
            微视
          </qc-radio>
          <qc-radio v-show="isBindKg" v-model="media" value="kg">
            全民K歌
          </qc-radio>
        </section>

        <div v-show="media === 'ws'" class="form">
          <div class="item">
            <div class="label">
              <span class="require">*</span>商品短标题
            </div>
            <div>
              <qc-input v-model="form.shortTitle" size="large" placeholder="不超过10个汉字" />
            </div>
          </div>
          <div class="item">
            <div class="label">
              商品标签
            </div>
            <div>
              <qc-input v-model="form.tags" size="large" placeholder="不同标签用#分隔，最长3个标签" />
            </div>
          </div>
        </div>
      </section>
      <footer class="footer">
        <qc-button @click="onPushUpGoods">
          上架
        </qc-button>
      </footer>
    </section>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import commonMixin from '@/mixins/common';
import { transformUrl, Validator } from '@/lib/helper';
import { errCodeMap } from '@/lib/errors';

export default {
  name: 'ChooseMediaPop',
  mixins: [commonMixin],
  data() {
    return {
      media: 'ws',
      form: {
        shortTitle: '',
        tags: '',
      },
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      chooseMediaPop: state => state.common.chooseMediaPop,
      wsCurrentMediaUser: state => state.common.wsCurrentMediaUser,
    }),
    ...mapGetters({
      isBindJd: 'userCenter/isBindJd',
      isBindWs: 'userCenter/isBindWs',
      isBindKg: 'userCenter/isBindKg',
    }),
    jdBindUrl() {
      return this.getBindUrl('京东');
    },
  },
  methods: {
    async onPushUpGoods() {
      if (!Validator.checkShortTitle(this.form.shortTitle)) {
        this.$tip({
          type: 'error',
          message: '标题不符合要求',
        });

        return;
      }

      const { item } = this.chooseMediaPop;

      const data = {
        saas_type: item.saas_type,
        saas_product_id: item.saas_product_id,
        saas_url: transformUrl(item.h5_url),
        media: this.media,
        media_id: this.wsCurrentMediaUser.media_id,
        material_info: JSON.stringify({
          tags: this.form.tags.split('#'),
          short_title: this.form.shortTitle,
        }),
      };

      const res = await this.$ajax.post('v1/cp/publishproduct/hot', {
        method: 'post',
        body: data,
      });

      if (res.code !== 0) {
        this.$tip.error(errCodeMap[res.code] || `错误码：${res.code}, 错误信息：${res.msg}`);

        return;
      }

      this.$tip.success('上架成功，请等待审核');
    },
    hideChooseMediaPop() {
      this.$store.commit('common/HIDE_CHOOSE_MEDIA_POP');
    },
  },
};
</script>


<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.choose-media-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .c-pri {
    color: red;
  }
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .radio-wrap {
    margin-left: 104px;
  }
  .form {
    width: 70%;
    margin: 40px auto;
    .item {
      margin-top: 20px;
      .label {
        min-width: 100px;
        .require {
          color: red;
          position: relative;
          left: -4px;
        }
      }
      display: flex;
    }
  }
  .pop-content {
    position: relative;
    width: 700px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
        .image {
          height: 234px;
        }
        &:nth-child(3) {
          margin: 0 10px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
}
</style>
